import { DatePipe } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { LiquidacaoService } from 'administrativo-lib';
import { AssinaturaService, FuncaoService, GlobalService, Login } from 'eddydata-lib';
import { MessageService } from 'primeng/api';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GrdLiquidacao } from '../../relatorio/liquidacao/grd-liquidacao';
import { warning } from 'toastr';

@Component({
  selector: 'app-grd-liquidacao-dlg',
  templateUrl: './grd-liquidacao-dlg.component.html'
})
export class GrdLiquidacaoDlgComponent implements OnInit, OnDestroy {

  protected datepipe: DatePipe;
  public ptBR: any;
  public selectedOrdem: string;
  public selectedOpt: string;
  public selectNaoImpresso: boolean;
  public selectUsuario: boolean;
  public dataInicio: Date;
  public dataFinal: Date;
  public numeroInicio: number;
  public numeroFinal: number;
  protected unsubscribe: Subject<void> = new Subject();

  public imaskNumero = {
    mask: Number,
    scale: 0,
    signed: false
  };

  @Input() login: Login;

  constructor(
    protected messageService: MessageService,
    private globalService: GlobalService,
    protected assinaturaService: AssinaturaService,
    private funcaoService: FuncaoService,
    private liquidacaoService: LiquidacaoService,
  ) { }

  ngOnInit() {
    this.ptBR = this.globalService.obterDataBR();
    this.datepipe = new DatePipe('pt');
    this.selectedOrdem = 'ord1';
    this.selectedOpt = 'opt1';
    this.selectNaoImpresso = false;
    this.selectUsuario = false;
    this.dataInicio = new Date();
    this.dataFinal = new Date();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  async imprimir() {
    const parametros = {};
    let relations = '';
    relations += 'empenho.contrato,empenho.licitacao,empenho.modalidade,empenho.subelemento,empenho.favorecido,';
    relations += 'empenho.ficha.executora.unidade,empenho.ficha.despesa,empenho.ficha.funcao,empenho.ficha.acao,empenho.ficha.aplicacao,retencoes,retencoes.ficha';
    parametros['relations'] = relations;
    parametros['exercicio_id'] = this.login.exercicio.id;
    parametros['orgao_id'] = this.login.orgao.id;

    if (this.selectedOpt === 'opt1') {
      if (!this.dataFinal || !this.dataFinal) {
        warning('Informe a data inicial e final');
        return
      } else {
        parametros['data_liquidacao$ge'] = this.datepipe.transform(this.dataInicio, 'yyyy-MM-dd');
        parametros['data_liquidacao$le'] = this.datepipe.transform(this.dataFinal, 'yyyy-MM-dd');
      }
    } else {
      if (!this.numeroInicio && !this.numeroFinal) {
        warning("Informe o numero final e inicial");
        return
      } 
      if ((this.numeroInicio && !this.numeroFinal) || (!this.numeroInicio && this.numeroFinal)) {
        this.numeroInicio ? parametros['empenho.numero'] = this.numeroInicio : parametros['empenho.numero'] = this.numeroFinal
      } else {
        parametros['empenho.numero$ge'] = this.numeroInicio;
        parametros['empenho.numero$le'] = this.numeroFinal;
      }
    }
    if (this.selectedOrdem === 'ord1') {
      parametros['orderBy'] = 'empenho.numero$ASC';
    } else if (this.selectedOrdem === 'ord2') {
      parametros['orderBy'] = 'empenho.favorecido.nome$ASC';
    } else {
      parametros['orderBy'] = 'data_cadastro$ASC';
    }
    if (this.selectNaoImpresso) {
      parametros['impresso'] = !this.selectNaoImpresso;
    }
    if (this.selectUsuario) {
      parametros['usuario_cadastro_id'] = this.login.usuario.id;
    }

    this.liquidacaoService
      .extendido(1, -1, parametros)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(lista => {
        const param = {};
        param['exercicio_id'] = this.login.exercicio.id;
        param['orgao.id'] = this.login.orgao.id;
        new GrdLiquidacao().imprimir(lista.content, this.login);
      },
        (e) => this.messageService.add(
          { severity: 'error', summary: 'Atenção!', detail: e.error && e.error.payload ? e.error.payload : e }
        )
      );      
  }

}
